import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { MenuItem, MenuItemProps, Select, SelectProps } from '@mui/material';
import { Key } from 'react';

export interface CustomSelectOption {
  id?: string;
  value: string | number;
  label: string;
  disabled?: boolean;
  icon?: string;
  address?: string;
}

export interface CustomSelectProps extends Omit<SelectProps, 'options'> {
  options: Array<CustomSelectOption>;
  itemHeight?: number;
  itemPaddingTop?: number;
  focusedBorderColor?: string;
  selectHeight?: number;
  borderColor?: string;
  menuListWidth?: number;
  paperPropsStyle?: React.CSSProperties;
  menuItemProps?: (option: CustomSelectOption) => MenuItemProps;
  renderMenuItem?: (option: CustomSelectOption) => React.ReactNode;
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MENU_LIST_WIDTH = 250;

export const CustomSelect = (props: CustomSelectProps) => {
  const {
    options,
    itemHeight = ITEM_HEIGHT,
    itemPaddingTop = ITEM_PADDING_TOP,
    selectHeight = '48px',
    focusedBorderColor,
    borderColor,
    menuListWidth = MENU_LIST_WIDTH,
    sx,
    paperPropsStyle,
    menuItemProps,
    renderMenuItem,
    ...rest
  } = props;
  return (
    <Select
      labelId='demo-multiple-name-label'
      id='demo-multiple-name'
      IconComponent={() => (
        <KeyboardArrowDownIcon
          sx={{
            width: '24px',
            height: '24px',
            color: 'white',
          }}
        />
      )}
      MenuProps={{
        MenuListProps: {
          style: {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
        PaperProps: {
          style: {
            maxHeight: itemHeight * 4.5 + itemPaddingTop,
            width: menuListWidth,
            paddingTop: 0,
            paddingBottom: 0,
            ...paperPropsStyle,
          },
        },
      }}
      sx={{
        color: 'white',
        fontSize: '14px',
        width: '100%',
        border: `1px solid ${borderColor || '#FFFFFF26'}`,
        height: selectHeight,
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: focusedBorderColor || 'white',
          borderWidth: '1px',
          margin: '-1px',
        },
        '&.MuiMenu-list': {
          paddingTop: 0,
          paddingBottom: 0,
        },
        ...sx,
      }}
      {...rest}>
      {options.map(option => {
        const { value, label, disabled } = option;
        return (
          <MenuItem
            key={value as Key}
            value={value}
            disabled={disabled}
            sx={{
              padding: '12px',
            }}
            {...(typeof menuItemProps === 'function' ? menuItemProps(option) : menuItemProps)}>
            {renderMenuItem ? renderMenuItem(option) : label}
          </MenuItem>
        );
      })}
    </Select>
  );
};
